"use client";

import { useEffect, useState } from "react";

import Progress from "@/components/ui/Progress";

export default function Example() {
  const [progress, setProgress] = useState(25);

  useEffect(() => {
    const timer = setTimeout(() => setProgress(100), 100);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        zIndex: 9999, // Ensure it stays on top of other content
      }}
    >
      <Progress value={progress} css={{}} />
    </div>
  );
}
